export enum VideoProviderType {
  YouTube = 'youtube',
  Brightcove = 'brightcove',
  Webinar = 'webinar',
  Countdown = 'countdown',
}
